import { clsx } from 'clsx'
import type { PropsWithChildren } from 'react'

import { FvButton } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

import { useDraggableButton } from './useDraggableButton'

type DraggableButtonProps = PropsWithClassName<
  PropsWithChildren<{
    buttonClassName?: string
    dragThreshold?: number
    margin?: number
    onClick: () => void
    storageKey: string
  }>
>

export const DraggableButton = ({
  buttonClassName,
  children,
  className,
  dragThreshold = 15,
  margin = 16,
  onClick,
  storageKey,
}: DraggableButtonProps) => {
  const {
    buttonRef,
    buttonStyle,
    containerStyle,
    handlePointerCancel,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
  } = useDraggableButton({
    dragThreshold,
    margin,
    onClick,
    storageKey,
  })

  return (
    <div
      className={clsx('fixed z-[2147483647]', className)}
      style={containerStyle}
    >
      <FvButton
        ref={buttonRef}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        onPointerCancel={handlePointerCancel}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick()
          }
        }}
        className={buttonClassName}
        style={buttonStyle}
      >
        {children}
      </FvButton>
    </div>
  )
}
